import { zodResolver } from '@hookform/resolvers/zod';
import { useEffect, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { useBudgetId } from '../../budget/budget-store';
import { useUpdateBucketApi } from '../api/use-update-bucket';
import { useAssignmentToBucketRequest } from '../bucket-utils';
import { z } from 'zod';
export const assignmentRequestSchema = z.object({
    month: z.coerce.number().min(1).max(12),
    year: z.coerce.number().min(1).max(9999),
    amount: z.coerce.number(),
});
export const useSaveAssignmentForm = (bucket, year, month, onSuccess) => {
    const budgetId = useBudgetId();
    const { mutate, isPending } = useUpdateBucketApi({ onSuccess });
    const assignmentToBucketRequest = useAssignmentToBucketRequest(bucket.id);
    const defaultValues = useMemo(() => {
        const assignment = bucket.assignments.find((a) => a.month === month && a.year === year);
        return {
            budgetId,
            bucketId: bucket.id,
            year: assignment?.year ?? year,
            month: assignment?.month ?? month,
            amount: assignment?.amount ?? 0,
        };
    }, [budgetId, bucket.id, bucket.assignments, year, month]);
    const form = useForm({
        resolver: zodResolver(assignmentRequestSchema),
        defaultValues,
    });
    useEffect(() => {
        form.reset(defaultValues);
    }, [defaultValues, form]);
    const handleSubmit = (values) => {
        mutate(assignmentToBucketRequest(values)).then(() => { });
    };
    return {
        form,
        onSubmit: form.handleSubmit(handleSubmit),
        isSubmitting: isPending,
    };
};
